if (!customElements.get('luv-inline-product-video')) {
  customElements.define('luv-inline-product-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.gallery = this.closest('media-gallery');
      this.slide = this.closest('.product__media-item');
      if (!this.video || !this.gallery || !this.slide) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.video.muted = true;
      this.video.playsInline = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reducedMotion.matches) {
        this.video.autoplay = false;
        this.video.pause();
      }

      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        this.syncPlayback();
      }, { threshold: [0, 0.35] });
      this.observer.observe(this);

      this.gallery.addEventListener('click', (event) => {
        if (event.target.closest('[id^="GalleryThumbnails"] [data-target] button')) {
          requestAnimationFrame(() => this.syncPlayback());
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      window.addEventListener('hashchange', () => {
        if (!this.gallery.querySelector('luv-product-reel') && window.location.hash === '#dana-extender-demo') this.selectVideo();
      }, options);

      customElements.whenDefined('media-gallery').then(() => {
        if (this.isConnected && !this.gallery.querySelector('luv-product-reel') && !this.gallery.dataset.inlineVideoInitialized) {
          this.gallery.dataset.inlineVideoInitialized = 'true';
          this.selectVideo();
        }
      });
    }

    selectVideo() {
      this.gallery.elements.viewer.initPages?.();
      this.gallery.elements.thumbnails?.initPages?.();
      this.gallery.setActiveMedia(this.slide.dataset.mediaId, false, false);
      requestAnimationFrame(() => this.syncPlayback());
    }

    syncPlayback() {
      if (!this.isConnected) return;
      if (!this.visible || document.hidden) {
        this.video.pause();
        return;
      }
      if (!this.reducedMotion.matches) this.video.play().catch(() => {});
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.video?.pause();
    }
  });
}
